import { GetSecureInformationRequestsByCorporationItem } from '@commenda/api';
import { Badge, Button, Dropdown, Icons, useToggle } from '@commenda/kakashi';
import {
  NonTimezoneSensitiveDate,
  RECURRING_USER_TASK_STATUS_ENUM_TO_TEXT,
} from '@commenda/utils';
import { RecurringUserTaskStatus } from '@prisma/client';
import { KeyedMutator } from 'swr';
import { AssignSecureInformationRequestToCAFirmModal } from './AssignSecureInformationRequestToCAFirmModal';
import { DeleteSecureInformationRequestModal } from './DeleteSecureInformationRequest';

const SecureInformationRequestRow = ({
  row,
  token,
  mutate,
  onShowSummary,
}: {
  row: GetSecureInformationRequestsByCorporationItem;
  token?: string;
  mutate: KeyedMutator<unknown>;
  onShowSummary: () => void;
}) => {
  const deleteSecureInformationRequestVisibility = useToggle();
  const assignCAFirmsModalVisibility = useToggle();

  return (
    <tr key={row.id}>
      <td className="whitespace-nowrap py-4 pr-3 text-sm pl-2">
        <div className="flex items-center">
          <div className="ml-4">
            <div className="font-medium text-gray-900">
              {row.corporation?.name}
            </div>
          </div>
        </div>
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {row.title}
      </td>
      <td
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role="button"
        aria-hidden="true"
        className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 cursor-pointer"
      >
        {NonTimezoneSensitiveDate.fromNativeDate(
          new Date(row.createdAt)
        ).format('MMM DD, YYYY')}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {NonTimezoneSensitiveDate.fromNativeDate(
          new Date(row.lastModifiedAt)
        ).format('MMM DD, YYYY')}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        <Badge
          size="sm"
          variant={
            row.recurringUserTask.status === RecurringUserTaskStatus.COMPLETED
              ? 'success'
              : 'gray'
          }
        >
          {
            RECURRING_USER_TASK_STATUS_ENUM_TO_TEXT[
              row.recurringUserTask.status
            ]
          }
        </Badge>
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {row.assignedCAFirms.map((caFirm) => caFirm.name).join(', ') || '-'}
      </td>
      <td>
        <Dropdown
          menu={{
            groups: [
              {
                items: [
                  {
                    label: 'View Summary',
                    onClick: onShowSummary,
                  },
                  {
                    label: 'Delete',
                    onClick: deleteSecureInformationRequestVisibility.show,
                  },
                  {
                    label: 'Assign CA Firms',
                    onClick: assignCAFirmsModalVisibility.show,
                  },
                ],
              },
            ],
          }}
        >
          <Button variant="tertiary" size="sm">
            <Icons.DotsVertical className="text-inherit" />
          </Button>
        </Dropdown>
      </td>

      <div>
        <DeleteSecureInformationRequestModal
          id={row.id}
          isShown={deleteSecureInformationRequestVisibility.visible}
          toggle={deleteSecureInformationRequestVisibility.toggle}
          token={token}
          mutate={mutate}
        />
        <AssignSecureInformationRequestToCAFirmModal
          isShown={assignCAFirmsModalVisibility.visible}
          toggle={assignCAFirmsModalVisibility.toggle}
          id={row.id}
          mutate={mutate}
          row={row}
        />
      </div>
    </tr>
  );
};

export { SecureInformationRequestRow };
